import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  class: "container",
  ref: "container"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_project_card = _resolveComponent("project-card")!

  return (_openBlock(), _createElementBlock("div", {
    class: "projects",
    style: _normalizeStyle({left: `${-_ctx.offset}px`})
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.projects, (project, i) => {
        return (_openBlock(), _createBlock(_component_project_card, {
          onClick: ($event: any) => (_ctx.onDetail(project)),
          project: project,
          key: i
        }, null, 8, ["onClick", "project"]))
      }), 128))
    ], 512)
  ], 4))
}